module.exports = __webpack_public_path__ + "files/a25021723cff250f4c94ab2ade1f6192.png";